import { Action, createReducer, on } from "@ngrx/store";
import { HOME_LOBBY_INIT_STATE, HomeLobbyState } from "./homeLobby.state";
import * as HomeLobbyActions from './homeLobby.actions';


const _homeLobbyReducer = createReducer( 
    HOME_LOBBY_INIT_STATE,

    on(
        HomeLobbyActions.activateHomeLobbyComponent,
        (state, action) => ({
            ...state,
            activeComponent: action.component,
        })
    ), 
)

export function homeLobbyReducer(state: HomeLobbyState, action: Action) {
    return _homeLobbyReducer(state, action);
}
